<template lang="pug">
v-dialog(
  v-model='computedShow',
  :persistent='persistent',
  :disabled='disabled',
  :fullscreen='fullscreen',
  :hide-overlay='hideOverlay',
  :max-width='maxWidth',
  :scrollable='scrollable',
  :style='{ borderRadius: borderRadius }'
  style='max-width: 100%;')
  v-card(
    :style='{ borderRadius: borderRadius, backgroundColor: backgroundColor }')
    v-toolbar.global-dialog-text(
      :style='{ background: `${headerColor} !important`, color: headerTitleColor, toolbarPadding }'
      style='z-index: 99999'
      v-if='toolbar')
      slot(name='header' v-if='$scopedSlots.header')
        //- Here you can also add your own customized header
        //- Then you don't need the "headerTitle", "closeIcon", "closeColor" props, for example
      template(v-else)
        v-card-title(style='word-break: break-word' :style="toolbarPadding" ) {{ headerTitle }}
        v-spacer
        v-btn#closeIcon(v-if='closeBtn' icon :color='closeColor' @click='$emit("clickCloseButton") && handleChange(false)')
          md-icon {{ closeIcon }}
    PerfectScrollbar
      v-card-text.text-md-left(style='padding: 24px 20px;')
        slot(name='content')
    v-card-actions(:style='buttonSectionPadding')
      slot(name='footer' v-if='$scopedSlots.footer')
        //- Here you can also add your own customized footer
      template(v-else)
        v-btn.elevation-0(
          v-if='showLButton'
          @click='$emit("clickLButton") && handleChange(false)',
          :loading='lButtonLoading'
          :style="lButtonStyle"
          text,
          :color='lButtonColor') {{ lButtonTitle }}
        v-spacer
        v-btn.elevation-0(
          style='margin-right: 8px;'
          :style='{ color: mButtonTextColor }'
          v-if='showMButton'
          @click='$emit("clickMButton")',
          :loading='mButtonLoading'
          :outlined="mButtonIsOutlined",
          :color='mButtonColor') {{ mButtonTitle }}
        v-btn.elevation-0(
          v-if='showRButton'
          @click='$emit("clickRButton")',
          :loading='rButtonLoading',
          :color='rButtonColor',
          :style='{color: rButtonTextColor }'
          :disabled='disabledRButton'
          style="margin-left: 1rem;") {{ rButtonTitle }}
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  model: {
    prop: 'show',
    event: 'update'
  },
  props: {
    toolbar: {
      type: Boolean,
      default: () => true
    },
    toolbarPadding: {
      type: String,
      default: () => 'padding: 0 16px'
    },
    show: {
      type: Boolean,
      default: () => false
    },
    borderRadius: {
      type: String,
      default: () => '4px'
    },
    lButtonStyle: {
      type: String,
      default: () => ''
    },
    closeBtn: {
      type: Boolean,
      default: () => true
    },
    // Close Icon Props
    closeIcon: {
      type: String,
      default: () => 'close'
    },
    closeColor: {
      type: String,
      default: () => 'white'
    },
    // Header Props
    headerTitle: {
      type: String,
      default: () => ''
    },
    headerColor: {
      type: String,
      default: () => 'linear-gradient(60deg, #66bb6a, #43a047)'
    },
    headerTitleColor: {
      type: String,
      default: () => 'white'
    },
    // Content Props
    backgroundColor: {
      type: String,
      default: () => ''
    },
    // Button Section Props
    buttonSectionPadding: {
      type: String,
      default: () => 'padding: 0 28px 28px'
    },
    // Right Button Props
    showRButton: {
      type: Boolean,
      default: () => true
    },
    rButtonLoading: {
      type: Boolean,
      default: () => false
    },
    rButtonTitle: {
      type: String,
      default: () => 'OK'
    },
    rButtonColor: {
      type: String,
      default: () => '#43a047'
    },
    rButtonTextColor: {
      type: String,
      default: () => '#fff'
    },
    // Left Button Props
    showLButton: {
      type: Boolean,
      default: () => true
    },
    lButtonLoading: {
      type: Boolean,
      default: () => false
    },
    lButtonTitle: {
      type: String,
      default: () => 'Cancelar'
    },
    lButtonColor: {
      type: String,
      default: () => ''
    },
    lButtonTextColor: {
      type: String,
      default: () => 'rgba(0,0,0,.87)'
    },
    // Middle Button Props
    showMButton: {
      type: Boolean,
      default: () => false
    },
    mButtonLoading: {
      type: Boolean,
      default: () => false
    },
    mButtonTitle: {
      type: String,
      default: () => ''
    },
    mButtonColor: {
      type: String,
      default: () => ''
    },
    mButtonIsOutlined: {
      type: Boolean,
      default: () => false
    },
    mButtonTextColor: {
      type: String,
      default: () => 'rgba(0,0,0,.87)'
    },
    // v-dialog Props
    persistent: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    fullscreen: {
      type: Boolean,
      default: () => false
    },
    'hide-overlay': {
      type: Boolean,
      default: () => false
    },
    'max-width': {
      default: () => '700px'
    },
    scrollable: {
      type: Boolean,
      default: () => false
    },
    disabledRButton: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    PerfectScrollbar
  },
  computed: {
    computedShow: {
      get: function () {
        return this.show
      },
      set: function (nV) {
        this.handleChange(nV)
      }
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('update', value)
    }
  }
}
</script>

<style scoped>
.global-dialog-text {
  font-size: 1.125rem;
  line-height: 1.4em;
  font-weight: 300;
  font-size: 18px;
}
</style>
